
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OTR_STATUS_CONFIG } from '../constants/otrStatusConfig';
import { OTRSelect } from './OTRSelect';

const ALL = '__all__';

export const OTRFilterBar = ({
  filters,
  onFilterChange,
  statusOptions = [],
}) => {
  const { t } = useTranslation();
  const hasFilter = !!filters.status;

  return (
    <div className="flex flex-wrap items-end gap-3 mb-6 p-3 sm:p-4 bg-white rounded-2xl border border-[var(--color-border)] shadow-sm">
      <div className="flex flex-col gap-1 w-full sm:w-auto">
        <label className="text-[10px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider ml-1">
          {t('outstation.status')}
        </label>

        <div className="w-full sm:min-w-[220px]">
          <OTRSelect
            value={filters.status || ALL}
            onChange={(value) =>
              onFilterChange({
                ...filters,
                status: value === ALL ? '' : value,
              })
            }
            options={[
              {
                value: ALL,
                label: t('outstation.allStatuses'),
              },
              ...statusOptions.map((status) => ({
                value: status,
                label:
                  t(`outstation.statusOptions.${status}`, {
                    defaultValue:
                      OTR_STATUS_CONFIG[status]?.label ||
                      String(status).replace(/_/g, ' '),
                  }),
              })),
            ]}
            compact
          />
        </div>
      </div>

      <button
        type="button"
        onClick={() => onFilterChange({})}
        disabled={!hasFilter}
        className="h-9 px-4 text-[12px] font-bold text-[var(--color-primary)] hover:bg-[var(--color-primary)]/5 rounded-xl transition-all disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent"
      >
        {t('outstation.resetFilters')}
      </button>
    </div>
  );
};
